import { i18n } from '@/plugins/i18n';

/**
 * Main subject grouping multiple criteria tocalculate vitality.
 * The VitalityGroup instance should be passed a 'key' parameter.
 * The key is used for multiple purposes, such as translations :
 * - message.VH_WHAT_<key> : 'Loading <what>', '<what> loaded', etc. See VH_LOADING, VH_WORKING, VH_READY, VH_ERROR
 */
class VitalityGroup {

  constructor(props) {
    this.key = props.key || '';
    this.titleTr = props.titleTr || '';
    this.dataInfo = props.dataInfo || [];
    this.weight = props.weight || 0;
    this.essentialCriteria = props.essentialCriteria || props.criteria || [];
    this.bonusCriteria = props.bonusCriteria || [];
    this.senseiIntroTr = props.senseiIntroTr || '';
    this.senseiOutroTr = props.senseiOutroTr || '';
  }

  get criteria() {
    return [...this.essentialCriteria, ...this.bonusCriteria];
  }

  set criteria(criteria) {
    const essential = [];
    const bonus = [];
    criteria.forEach((criterion) => {
      if (this.essentialCriteria.some(({ key }) => key === criterion.key)) {
        essential.push(criterion);
      } else if (this.bonusCriteria.some(({ key }) => key === criterion.key)) {
        bonus.push(criterion);
      }
    });
    this.essentialCriteria = essential;
    this.bonusCriteria = bonus;
  }

  /**
   * Sentence that should be used as an introduction when teaching the use of this VitalityGroup
   * @return {String} Text
   */
  get senseiIntro() {
    if (this.senseiIntroTr === '') {
      const trKey = `sensei.VH_${this.key.toUpperCase()}_INTRO`;
      const tr = i18n.t(trKey);
      return trKey === tr ? '' : tr;
    }
    return i18n.t(this.senseiIntroTr);
  }

  /**
   * Sentence that should be used as a conclusion when teaching the use of this VitalityGroup
   * @return {String} Text
   */
  get senseiOutro() {
    if (this.senseiOutroTr === '') {
      const trKey = `sensei.VH_${this.key.toUpperCase()}_OUTRO`;
      const tr = i18n.t(trKey);
      return trKey === tr ? '' : tr;
    }
    return i18n.t(this.senseiOutroTr);
  }
}

export default VitalityGroup;
